import { render, staticRenderFns } from "./bindBankCard.vue?vue&type=template&id=8adce192&scoped=true&"
import script from "./bindBankCard.vue?vue&type=script&lang=js&"
export * from "./bindBankCard.vue?vue&type=script&lang=js&"
import style0 from "./bindBankCard.vue?vue&type=style&index=0&id=8adce192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adce192",
  null
  
)

export default component.exports